import { render, staticRenderFns } from "./app-detail-pcranklist.vue?vue&type=template&id=7053da88&scoped=true&"
import script from "./app-detail-pcranklist.vue?vue&type=script&lang=js&"
export * from "./app-detail-pcranklist.vue?vue&type=script&lang=js&"
import style0 from "./app-detail-pcranklist.vue?vue&type=style&index=0&id=7053da88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7053da88",
  null
  
)

export default component.exports